<ng-template #reusableTable let-isModal="isModal">
  <div *ngIf="(loadingService.getLoadingState('eligibleSystemsTable') | async); else tableContent"
    class="loading-container">
    <sh-spinner label="Loading systems data..."></sh-spinner>
  </div>


  <ng-template #tableContent>
      <div class="pagination-toolbar-container">
        <div class="pagination-left">
          <div class="pagination-info"  *ngIf="!isShowAllSystems()">
            #{{ getDisplayedRecordsCountBegin() }} -
            {{ getDisplayedRecordsCount() }} / {{ totalRecords }} Total
          </div>
          <div class="pagination-info"  *ngIf="isShowAllSystems()">
            {{ totalRecords }} Total
          </div>
        </div>
      <div class="result-view-toolbar">
        <div class="global-search-container">
          <sh-search [id]="'tt-globalsearch-' + (isModal ? 'm' : 'p')" label='Global Search' [(ngModel)]="globalSearchTerm"
            (ngModelChange)="onGlobalSearchChange()"></sh-search>
          <sh-tooltip delay [target]="'tt-globalsearch-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.globalSearch' | translate" placement="top" variation="long"></sh-tooltip>
        </div>

        <div class="result-view-select-wrapper">
          <sh-dropdown [id]="'tt-resultview-' + (isModal ? 'm' : 'p')" class="result-view-dropdown"
            label="Select View" [value]="displayedResultViewName" editable no-clear condensed
            (value-changed)="onResultViewDropdownChange($event)">
            <sh-menu-item *ngFor="let view of savedResultViews" [label]="view.name"
              [active]="view.name === selectedResultViewName">
              <sh-icon *ngIf="view.isDefault" icon="favorite" size="xs"
                class="default-result-view-icon" slot="functions"></sh-icon>
            </sh-menu-item>
          </sh-dropdown>
          <sh-tooltip delay [target]="'tt-resultview-' + (isModal ? 'm' : 'p')" label="Select a saved result view" placement="top" variation="short"></sh-tooltip>

          <sh-icon [id]="'tt-saveview-' + (isModal ? 'm' : 'p')" icon="save" color="black" size="m"
            [class.disabled-icon]="isSaveViewDisabled"
            (click)="!isSaveViewDisabled && openSaveResultViewModal()"
            (keydown)="!isSaveViewDisabled && openSaveResultViewModal()"></sh-icon>
          <sh-tooltip delay [target]="'tt-saveview-' + (isModal ? 'm' : 'p')" label="Save Result View" placement="top" variation="short"></sh-tooltip>

          <ng-container *ngIf="selectedResultViewName">
            <sh-icon [id]="'tt-viewmenu-' + (isModal ? 'm' : 'p')" icon="more" color="black" size="m"
              (click)="toggleResultViewMenu()"
              (keydown)="toggleResultViewMenu()"></sh-icon>
            <sh-tooltip delay [target]="'tt-viewmenu-' + (isModal ? 'm' : 'p')" label="More view options" placement="top" variation="short"></sh-tooltip>

            <sh-popover sticky [visible]="showResultViewMenu" [target]="'tt-viewmenu-' + (isModal ? 'm' : 'p')"
              class="result-view-menu-popover" style="z-index: 103;">
              <ul class="result-view-menu-list">
                <li (click)="openSaveAsNewResultViewModal()" (keydown)="openSaveAsNewResultViewModal()">Save as new view</li>
                <li (click)="deleteResultView()" (keydown)="deleteResultView()">Delete view</li>
                <li [class.disabled]="isSelectedViewDefault" (click)="setResultViewAsDefault()" (keydown)="setResultViewAsDefault()">Set as Default view</li>
                <li (click)="openRenameResultViewModal()" (keydown)="openRenameResultViewModal()">Rename</li>
              </ul>
            </sh-popover>
          </ng-container>
        </div>

        <div class="toolbar">
          <ng-container>
            <!-- IVK View Scroller: shown only when related workstation/component/license data exists -->
            <div
              class="ivk-view-scroller"
              *ngIf="ivkViews.length > 1"
              [attr.id]="'ivk-view-dots-trigger-' + (isModal ? 'm' : 'p')">
              <div
                *ngFor="let view of ivkViews; let i = index"
                class="ivk-view-dots"
                (mouseenter)="onActiveDotMouseEnter(i)"
                (mouseleave)="onActiveDotMouseLeave(i)">
                <button
                  [id]="`${view.label}-${i}`"
                  type="button"
                  class="ivk-dot"
                  [class.ivk-dot--active]="i === activeViewIdx"
                  [class.ivk-dot--system]="view.type === 'system'"
                  [class.ivk-dot--workstation]="view.type === 'workstation'"
                  [class.ivk-dot--component]="view.type === 'component'"
                  [class.ivk-dot--license]="view.type === 'license'"
                  (click)="onDotClick(i, $event, isModal)">
                </button>
                <sh-tooltip 
                  delay [target]="`${view.label}-${i}`" 
                  [label]="view.label" 
                  placement="top" variation="short">
                </sh-tooltip>
              </div>
              <sh-popover
                sticky
                [visible]="showViewPopover"
                [target]="'ivk-view-dots-trigger-' + (isModal ? 'm' : 'p')"
                label=""
                style="z-index: 104;">
                <div (mouseenter)="onIvkScrollerMouseEnter()" (mouseleave)="onIvkScrollerMouseLeave()">
                  <div
                    *ngFor="let view of ivkViews; let i = index"
                    class="ivk-popover-item"
                    [class.ivk-popover-item--active]="i === activeViewIdx"
                    (click)="selectView(i)">
                    {{ view.label }}
                  </div>
                </div>
              </sh-popover>
            </div>
            <sh-icon icon="layout-3x1" color="black" size="m" id="target-2a" (click)="toggleColumnVisibilityPopup()"></sh-icon>
            <!-- Column Visibility Popup -->
            <sh-popover sticky [visible]="showColumnVisibilityPopup" target="target-2a"
               class="column-visibility-popover" style="z-index: 103;">

              <sh-text [id]="'tt-choosecols-' + (isModal ? 'm' : 'p')" size="title" style="display:block; font-weight:600; margin-bottom:8px;">Choose Columns</sh-text>

              <sh-search [id]="'tt-searchcols-' + (isModal ? 'm' : 'p')" condensed label="Search columns" no-border
                [(ngModel)]="columnSearchTerm"
                (ngModelChange)="onColumnSearch($event)">
              </sh-search>

              <ul class="column-visibility-list" style="list-style-type: none; margin-top: 8px; overflow-y: auto; max-height: 30vh;">
                <li *ngIf="selectedFilteredColumns.length > 0">
                  <sh-text [id]="'tt-selected-' + (isModal ? 'm' : 'p')" size="body-2" style="font-weight:600; padding: 4px 0;">Selected</sh-text>
                </li>
                <li *ngFor="let column of selectedFilteredColumns">
                  <sh-checkbox [label]="column.displayName" [(ngModel)]="column.visible"
                    (checked)="onColumnVisibilityChange(column, $event)" />
                </li>

                <li *ngIf="unselectedFilteredColumns.length > 0" style="margin-top: 8px;">
                  <sh-text [id]="'tt-notselected-' + (isModal ? 'm' : 'p')" size="body-2" style="font-weight:600; padding: 4px 0;">Not Selected</sh-text>
                </li>
                <li *ngFor="let column of unselectedFilteredColumns">
                  <sh-checkbox [label]="column.displayName" [(ngModel)]="column.visible"
                    (checked)="onColumnVisibilityChange(column, $event)" />
                </li>
              </ul>

              <sh-button label="Close" slot='footer' color="Tertiary" size="auto"
                [id]="'tt-closecols-' + (isModal ? 'm' : 'p')"
                (click)="toggleColumnVisibilityPopup()"
                (keydown)="toggleColumnVisibilityPopup()"></sh-button>
            </sh-popover>
            <sh-tooltip delay target="target-2a" [label]="'eligible-table-header.tooltip.columnChooser' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-choosecols-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.chooseColumns' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-searchcols-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.searchColumns' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-selected-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.selectedLabel' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-notselected-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.notSelectedLabel' | translate" placement="top" variation="long"></sh-tooltip>
            <sh-tooltip delay [target]="'tt-closecols-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.closeColumns' | translate" placement="top" variation="short"></sh-tooltip>
          </ng-container>
          <sh-icon [id]="'tt-expand-' + (isModal ? 'm' : 'p')" [icon]="isTableExpanded ? 'exit-fullscreen' : 'fullscreen'"
            size="m" (click)="toggleTableExpand()" (keydown)="toggleTableExpand()">
          </sh-icon>
          <sh-tooltip delay [target]="'tt-expand-' + (isModal ? 'm' : 'p')" [label]="(isTableExpanded ? 'eligible-table-header.tooltip.collapse' : 'eligible-table-header.tooltip.expand') | translate" placement="top" variation="short"></sh-tooltip>

          <sh-icon
            [id]="'tt-export-' + (isModal ? 'm' : 'p')"
            icon="export-to-xls"
            color="black"
            size="m"
            [class.disabled-icon]="isExporting"
            (click)="!isExporting && exportToExcel()"
            (keydown)="!isExporting && exportToExcel()">
          </sh-icon>
          <sh-tooltip delay [target]="'tt-export-' + (isModal ? 'm' : 'p')" [label]="(isExporting ? 'Exporting...' : ('eligible-table-header.tooltip.export' | translate))" placement="top" variation="long"></sh-tooltip>
        </div>
      </div>
    </div>
    <!-- PrimeNG Table -->
    <div class="eligible-systems-table-shell" [attr.data-table-mode]="isModal ? 'modal' : 'page'">
     <p-table [value]="filteredData" [totalRecords]="totalRecords"
      styleClass="p-datatable-sm eligible-systems-grid"
      [scrollable]="isScrollableNeeded() || useVirtualScroll()"
      [scrollHeight]="(isScrollableNeeded() || useVirtualScroll()) ? getTableScrollHeight() : ''"
      [reorderableColumns]="true"
      (onColReorder)="onColumnReorder($event)"
      [customSort]="true"
      (onSort)="onSort($event)"
      [virtualScroll]="useVirtualScroll()"
      [virtualScrollItemSize]="25">
      <ng-template pTemplate="header">

        <tr class="group-header-row" *ngIf="visibleColumnGroups.length > 0">
          <th *ngFor="let group of visibleColumnGroups" [attr.colspan]="group.colspan"
            [attr.data-ivk-group-key]="group.key" scope="col">
          </th>
        </tr>

      <tr class="column-header-row">
          <th *ngFor="let column of visibleTableColumns; let i = index" pReorderableColumn scope="col"
            [attr.data-ivk-column-group]="getColumnIvkGroup(column)"
            [attr.data-ivk-column-index]="getColumnIvkIndex(column)"
            [pSortableColumn]="getSortableColumnField(column)">
            <div class="column-header-content">
              <div class="column-title-sort" [id]="'tt-sort-' + (isModal ? 'm' : 'p') + '-' + i">
                <sh-text class="column-title" color="primary" size="header-4">{{ column.displayName }}</sh-text>
                <p-sortIcon *ngIf="column.isSortable !== false" [field]="getSortableColumnField(column)"></p-sortIcon>
              </div>
              <sh-tooltip *ngIf="column.isSortable !== false" delay [target]="'tt-sort-' + (isModal ? 'm' : 'p') + '-' + i" [label]="'eligible-table-header.tooltip.sort' | translate" placement="top" variation="short"></sh-tooltip>
            </div>
          </th>
        </tr>
         <tr class="column-filter-row">
          <th *ngFor="let column of visibleTableColumns; let i = index" pReorderableColumn scope="col"  class="underline-filter-tr">
            <div *ngIf="column.isFilterable" class="filter-container">
              <sh-input-text *ngIf="column.filterType === 'text'" [id]="'tt-colfilter-' + (isModal ? 'm' : 'p') + '-' + i" type="text" condensed
                [(ngModel)]="columnSearchFilters[column.colName]" [label]="column.displayName" maxlength="30">
              </sh-input-text>
              <sh-tooltip *ngIf="column.filterType === 'text'" delay [target]="'tt-colfilter-' + (isModal ? 'm' : 'p') + '-' + i" [label]="'eligible-table-header.tooltip.columnFilter' | translate" placement="top" variation="short"></sh-tooltip>
              <sh-dropdown *ngIf="column.filterType === 'select' || column.filterType === 'booleanSelect'"
                [id]="'tt-colfiltersel-' + (isModal ? 'm' : 'p') + '-' + i"
                [label]="column.displayName" [(ngModel)]="columnSearchFilters[column.colName]" editable condensed>
                <sh-menu-item *ngFor="let option of column.selectOptions" [label]="option.value"></sh-menu-item>
              </sh-dropdown>
              <sh-tooltip *ngIf="column.filterType === 'select' || column.filterType === 'booleanSelect'" delay [target]="'tt-colfiltersel-' + (isModal ? 'm' : 'p') + '-' + i" [label]="'eligible-table-header.tooltip.columnFilterSelect' | translate" placement="top" variation="short"></sh-tooltip>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-system>
        <tr [ngClass]="{'grey-row' :system['NewEntryStatus'] === 'To be reviewed'}">
          <td *ngFor="let column of visibleTableColumns">
              <sh-text>
              {{ system[column.colName] }}
              </sh-text>
          </td>
        </tr>
      </ng-template>
            <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleTableColumns.length">
            <div *ngIf="tableMessage; else noDataMsg" class="table-empty-message" [ngClass]="{
              'table-message-error': tableMessageType === 'error',
              'table-message-info': tableMessageType === 'info'
            }">
              <sh-icon [icon]="tableMessageType === 'error' ? 'error' : 'information'" size="s"></sh-icon>
              <span>{{ tableMessage }}</span>
            </div>
            <ng-template #noDataMsg>
              <div class="table-empty-message table-message-info">
                <sh-icon icon="information" size="s"></sh-icon>
                <span>No data found</span>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </ng-template>
  <div class="pagination-container">
    <sh-pagination *ngIf="totalRecords != 0" [id]="'tt-pagination-' + (isModal ? 'm' : 'p')" [pages]="getTotalPages()" [(current-page)]="pageIndex"
      (previous-page-move)="loadPreviousPage($event)" (next-page-move)="loadNextPage($event)"
      (clicked-page-move)="loadSelectedPage($event)" class="paginination-row"></sh-pagination>
    <sh-tooltip *ngIf="totalRecords != 0" delay [target]="'tt-pagination-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.pagination' | translate" placement="top" variation="short"></sh-tooltip>
    <sh-dropdown *ngIf="totalRecords != 0" [id]="'tt-pagesize-' + (isModal ? 'm' : 'p')" [value]="pageSize" condensed [label]=""
      (value-changed)="pagePerRow($event)" class="page-size-dropdown">
      <sh-menu-item *ngFor="let option of pageSizeOptions" [label]="option"></sh-menu-item>
    </sh-dropdown>
    <sh-tooltip *ngIf="totalRecords != 0" delay [target]="'tt-pagesize-' + (isModal ? 'm' : 'p')" [label]="'eligible-table-header.tooltip.pageSize' | translate" placement="bottom" variation="long"></sh-tooltip>
  </div>
</ng-template>

<div *ngIf="showEligibleSystems && !isTableExpanded">
  <a id="volume-table-anchor"></a>
  <sh-card>
    <div class="displayFlex" slot="header">
      <sh-text size="header-1">
        {{ 'eligible-table-header.label.name' | translate }}
      </sh-text>
      <div class="parent-timer" *ngIf="apiCallStartTime">
        <div class="timer"> 
          <sh-icon icon="timer" size="s"></sh-icon>
          <sh-text class="align-text-duration" size="body-2">{{ timerDuration }}</sh-text>
        </div>  
      </div>
    </div>

    <!-- <sh-tabs>
      <sh-tab-item label="Manual results" [active]="activeTab === 'manual'"
        (click)="setActiveTab('manual')"></sh-tab-item>
      <!-- <sh-tab-item label="LLM results" [active]="activeTab === 'llm'" (click)="setActiveTab('llm')"></sh-tab-item> -->
    <!-- </sh-tabs> -->
    <div *ngIf="!isTableExpanded">
      <ng-container *ngTemplateOutlet="reusableTable; context: { isModal: false }"></ng-container>
    </div>
  </sh-card>
</div>

<sh-modal class="expand-table-modal" [visible]="isTableExpanded" label='Affected Volume'
  modal-height='90vh' modal-width='95vw'
  (modal-closed)="closeExpandedTable()"
  (closed)="closeExpandedTable()">
  <ng-container *ngTemplateOutlet="reusableTable; context: { isModal: true }"></ng-container>
</sh-modal>

<sh-modal class="save-result-view-modal" [visible]="showSaveResultViewModal" label="Create Result View"
  modal-height="360px" modal-width="480px"
  (modal-closed)="closeSaveResultViewModal()" (closed)="closeSaveResultViewModal()">

  <div class="save-result-view-body">
    <sh-dropdown id="tt-resultview-name" class="result-view-name-dropdown" condensed mandatory editable no-clear
      label="Add view name" [value]="resultViewNameInput" maxlength="50"
      (value-changed)="onResultViewNameInput($event)">
      <sh-menu-item *ngFor="let name of similarResultViewNames" [label]="name"></sh-menu-item>
    </sh-dropdown>

    <sh-text *ngIf="resultViewNameError" size="body-2" class="result-view-name-error">
      {{ resultViewNameError }}
    </sh-text>

    <sh-text *ngIf="isDuplicateResultViewName && !resultViewNameError" size="body-2" class="result-view-name-duplicate-hint">
      This name already exists. Choose "Overwrite" or type a new name.
    </sh-text>

    <sh-checkbox id="tt-resultview-default" label="Set as Default view"
      [active]="setAsDefaultResultView" (checked)="setAsDefaultResultView = !setAsDefaultResultView">
    </sh-checkbox>
  </div>

  <sh-button id="tt-resultview-cancel" slot="footer" color="Tertiary" size="auto" label="Cancel"
    (click)="closeSaveResultViewModal()"
    (keydown)="closeSaveResultViewModal()"></sh-button>
  <sh-button id="tt-resultview-save" slot="footer" size="auto"
    [label]="isDuplicateResultViewName ? 'Overwrite' : 'Save'"
    [disabled]="!resultViewNameInput || !resultViewNameInput.trim()"
    (click)="saveOrOverwriteResultView()"
    (keydown)="saveOrOverwriteResultView()"></sh-button>
</sh-modal>

<app-notification [notification]="notification"></app-notification>